import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'MainPage',
      component: () =>
        import(
          /* webpackChunkName: "MainPage" */
          './components/MainPage.vue'
        ),
      meta: () => ({
        requiresAuth: false,
        title: 'Widget - User Home',
      }),
    },

    {
      path: '/auth/:provider',
      name: 'AuthTication',
      component: () =>
        import(
          /* webpackChunkName: "auth-flow" */
          './components/commons/Auth.vue'
        ),
      meta: () => ({
        requiresAuth: false,
        title: 'Widget - Google Auth',
      }),
    },
  ],
})
export default router
